<div class="container">
  <!-- Standard Breadcrumbs -->
  <nav aria-label="Breadcrumb" *ngIf="!arrow">
    <ol class="breadcrumbs">
      <li *ngFor="let item of rotas; let last = last" [class.current]="last">{{item}}</li>
    </ol>
  </nav>

  <!-- Arrow Breadcrumbs -->
  <nav aria-label="Breadcrumb" *ngIf="arrow">
    <ol class="breadcrumbs arrow">
      <li *ngFor="let item of rotas; let last = last" [class.current]="last">{{item}}</li>
<!--      <li><a href="#">Products</a></li>-->
<!--      <li><a href="#">Electronics</a></li>-->
<!--      <li class="current">Smartphones</li>-->
    </ol>
  </nav>
</div>
